import { render, staticRenderFns } from "./video-call-notification-popup.html?vue&type=template&id=2b8bc6af&scoped=true&external"
import script from "./video-call-notification-popup.js?vue&type=script&lang=js&external"
export * from "./video-call-notification-popup.js?vue&type=script&lang=js&external"
import style0 from "./video-call-notification-popup.scss?vue&type=style&index=0&id=2b8bc6af&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8bc6af",
  null
  
)

export default component.exports